import { Box, Card, Divider, Stack, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { PROMPT_SLIDES } from "../../constants";
import { PromptSlideId } from "../../types";
import PromptSlides from "../PromptSlides";

interface InstructionsBlockProps {
  activeSlideId: PromptSlideId;
  skippedPromptIds: PromptSlideId[];
  setSkippedPromptIds: Dispatch<SetStateAction<PromptSlideId[]>>;
  setActiveSlideId: Dispatch<SetStateAction<PromptSlideId>>;
}

const InstructionsBlock = ({
  activeSlideId,
  skippedPromptIds,
  setSkippedPromptIds,
  setActiveSlideId,
}: InstructionsBlockProps) => {
  const handleToggleSkipPrompt = (slideId: PromptSlideId) => {
    setSkippedPromptIds((prevState) => {
      if (prevState.includes(slideId)) return prevState.filter((item) => item !== slideId);

      const nextState = [...prevState, slideId];
      if (slideId === activeSlideId) {
        const nextSlide = PROMPT_SLIDES.find((item) => !nextState.includes(item.id));
        if (nextSlide) setActiveSlideId(nextSlide.id);
      }

      return nextState;
    });
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={1.5}>
        <Box>
          <Typography variant='h6'>Дополнительные инструкции</Typography>
          <Typography color='text.secondary'>
            Уточните стиль вопросов, критериев или тональность. Эти блоки можно пропускать.
          </Typography>
        </Box>
        <Divider />
        <PromptSlides
          activeSlideId={activeSlideId}
          skippedPromptIds={skippedPromptIds}
          onChangeActiveSlide={setActiveSlideId}
          onToggleSkip={handleToggleSkipPrompt}
        />
      </Stack>
    </Card>
  );
};

export default InstructionsBlock;
